import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { post } from "../../services/api";
import { useNavigate } from "react-router-dom";

const ChangePassword = () => {
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isSubmitting },
    reset,
  } = useForm();

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const saveData = async (data) => {
    if (!token || !userId) {
      toast.error("Authentication required. Please login again.");
      return;
    }

    try {
      const response = await post(
        "UserAuthentication/ChangePassword",
        {
          userId: parseInt(userId, 10),
          currentPassword: data.currentPassword,
          newPassword: data.newPassword,
          confirmPassword: data.confirmPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.isSuccess) {
        toast.success("Password changed successfully!");
        reset();
        // navigate("/");
      } else {
        toast.error(response.message || "Password change failed");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.title ||
          "Failed to change password. Please try again."
      );
    }
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Change Password</h2>
      </div>
      <div className="row g-3">
        <div className="col-md-5">
          <div className="card">
            <div className="card-body p-4">
              <form
                className="row g-3 new-form-style"
                onSubmit={handleSubmit(saveData)}
              >
                {/* Current Password Field */}
                <div className="col-12 position-relative">
                  <label className="form-label form-label-new">
                    Current Password<span className="text-danger fs-9">*</span>
                  </label>
                  <div className="position-relative">
                    <input
                      {...register("currentPassword", {
                        required: "This field is required.",
                      })}
                      type={showCurrentPassword ? "text" : "password"}
                      className="form-control pe-5"
                    />
                    <button
                      type="button"
                      className="btn btn-link position-absolute end-0 top-50 translate-middle-y p-0 me-3"
                      onClick={() =>
                        setShowCurrentPassword(!showCurrentPassword)
                      }
                    >
                      <i
                        className={`fas ${
                          showCurrentPassword ? "fa-eye-slash" : "fa-eye"
                        } text-secondary`}
                      ></i>
                    </button>
                  </div>
                  {errors.currentPassword && (
                    <div className="mt-1 text-danger small">
                      {errors.currentPassword.message}
                    </div>
                  )}
                </div>

                {/* New Password Field */}
                <div className="col-12 position-relative">
                  <label className="form-label form-label-new">
                    New Password<span className="text-danger fs-9">*</span>
                  </label>
                  <div className="position-relative">
                    <input
                      {...register("newPassword", {
                        required: "This field is required.",
                        minLength: {
                          value: 6,
                          message:
                            "Password must be at least 6 characters long.",
                        },
                      })}
                      type={showNewPassword ? "text" : "password"}
                      className="form-control pe-5"
                    />
                    <button
                      type="button"
                      className="btn btn-link position-absolute end-0 top-50 translate-middle-y p-0 me-3"
                      onClick={() => setShowNewPassword(!showNewPassword)}
                    >
                      <i
                        className={`fas ${
                          showNewPassword ? "fa-eye-slash" : "fa-eye"
                        } text-secondary`}
                      ></i>
                    </button>
                  </div>
                  {errors.newPassword && (
                    <div className="mt-1 text-danger small">
                      {errors.newPassword.message}
                    </div>
                  )}
                </div>

                {/* Confirm Password Field */}
                <div className="col-12 position-relative">
                  <label className="form-label form-label-new">
                    Confirm Password<span className="text-danger fs-9">*</span>
                  </label>
                  <div className="position-relative">
                    <input
                      {...register("confirmPassword", {
                        required: "This field is required.",
                        validate: (value) =>
                          value === watch("newPassword") ||
                          "Passwords do not match.",
                      })}
                      type={showConfirmPassword ? "text" : "password"}
                      className="form-control pe-5"
                    />
                    <button
                      type="button"
                      className="btn btn-link position-absolute end-0 top-50 translate-middle-y p-0 me-3"
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                    >
                      <i
                        className={`fas ${
                          showConfirmPassword ? "fa-eye-slash" : "fa-eye"
                        } text-secondary`}
                      ></i>
                    </button>
                  </div>
                  {errors.confirmPassword && (
                    <div className="mt-1 text-danger small">
                      {errors.confirmPassword.message}
                    </div>
                  )}
                </div>

                {/* Submit Button */}
                <div className="col-12">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <span
                        className="spinner-border spinner-custom-size me-1"
                        aria-hidden="true"
                      ></span>
                    ) : null}
                    <span role="status">Save</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
